let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1pM4O")).then(() => parcelRequire('2pWnv'));